import React, { useEffect, useRef } from 'react';
import { View } from 'react-native'
import { FooterStyles } from 'styles/components/organisms/Footer'
import _ from "lodash";
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import ThemedButtonContainer from 'components/atoms/ThemedButtonContainer'
import HelperPlatform from 'utils/helper-platform'
import { pageContentWidths } from 'styles/page-content'


const FooterBar = ( { items, buttons, buttonContainerProps = {}, visible = true, onHeightCallback } ) => {
	
	const insets = useSafeAreaInsets();
	const containerHeight = useRef( undefined )
	
	let containerStyle = {
		paddingBottom: insets?.bottom > 0 ? insets?.bottom : 12,
	}
	
	if( HelperPlatform.isWeb() ) {
		containerStyle = {
			...containerStyle,
			alignItems: 'center',
			alignSelf: 'center',
			position: 'absolute',
			margin: 0,
			width: '100%',
			left: 0,
			right: 0,
		}
	}
	
	const containerStyles = [ FooterStyles.container, containerStyle ];
	
	useEffect( () => {
		if( containerHeight.current !== undefined && _.isFunction( onHeightCallback ) ) {
			onHeightCallback( containerHeight.current )
		}
	}, [ onHeightCallback ] );
	
	if( !visible ) {
		return null
	}
	
	return (
		<View
			style={ containerStyles }
			onLayout={ event => {
				const { height, } = event.nativeEvent.layout;
				
				containerHeight.current = height;
				
				if( onHeightCallback ) {
					onHeightCallback( height )
				}
			}}>
			
			{ !_.isEmpty( buttons ) && (
				<ThemedButtonContainer
					{...buttonContainerProps}
						style={ [ HelperPlatform.isWeb() ? { width: '100%', maxWidth: pageContentWidths.narrow } : null, buttonContainerProps.style ] }
					padding={ false }>
					
					{ buttons }
				</ThemedButtonContainer>
			)}
		</View>
	)
}

export default FooterBar;
